// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import machineStatusUpdates from './machine-status-updates';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export default {
    machineStatusUpdate: combineReducers({
        busyCounter,
        facets,
        hasSearchResults,
        machineStatusUpdates,
        reportsAccordion,
        searchByDropDown,
        searchFilters,
        searchQueryString
    })
};



// WEBPACK FOOTER //
// ./src/product/machine-status-update/reducers/index.js